import {charcoal} from '../sass/base/_exports.sass';

export const CalendarIcon = (props) => {
  const {color = charcoal, width = 25, height = 25, className = '', style = {}} = props;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 25"
      className={className}
      style={style}
      fill={color}
    >
      <g transform="translate(0 0)">
        <path
          d="M23.229,3.41a4.584,4.584,0,0,1,4.716,4.44V22.505a4.584,4.584,0,0,1-4.716,4.44H7.661a4.584,4.584,0,0,1-4.716-4.44V7.85A4.584,4.584,0,0,1,7.661,3.41l1.511.043V2.721a.826.826,0,0,1,1.648,0l-.046.689,9.3.043V2.721a.826.826,0,0,1,1.648,0l-.046.689ZM26.3,22.505h0V7.85a2.985,2.985,0,0,0-3.068-2.887l-1.511-.043v.733a.826.826,0,0,1-1.648,0l.046-.689-9.3-.043v.733a.826.826,0,0,1-1.648,0l.046-.689H7.661A2.985,2.985,0,0,0,4.593,7.85V22.505a2.985,2.985,0,0,0,3.068,2.887H23.229A2.985,2.985,0,0,0,26.3,22.505ZM15.445,7.807a8.084,8.084,0,0,1,5.536,2.159,7.159,7.159,0,0,1,2.293,5.212,7.611,7.611,0,0,1-7.83,7.371,7.611,7.611,0,0,1-7.83-7.371A7.611,7.611,0,0,1,15.445,7.807Zm0,13.189a6.015,6.015,0,0,0,6.182-5.818,6.008,6.008,0,0,0-6.182-5.818,6.008,6.008,0,0,0-6.182,5.818A6.008,6.008,0,0,0,15.445,21Zm0,0h0Zm3.938-5.818a.8.8,0,0,1-.833.775h-3.1a.726.726,0,0,1-.778-.733l-.046-.043.046-3.707-.046.043a.825.825,0,0,1,1.647.008v-.008L16.223,14.4l2.381.043-.046-.043A.8.8,0,0,1,19.383,15.178Z"
          transform="translate(-2.945 -1.945)"
        />
      </g>
    </svg>
  );
};
